// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12PwA","newExpiryDate":"styles_newExpiryDate__2b9ix","footer":"styles_footer__3Zk04"};